import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { EnderecoDTO } from "../../components/recadastramento-aba4/endereco.dto";
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class EnderecoViaCep extends GenericService {
    constructor(http: HttpClient) {
        super(http);
    }

    buscarEnderecoViaCep(cep: string): Observable<EnderecoDTO> {
        const url = `https://viacep.com.br/ws/${cep}/json/`;
        return this.http.get<EnderecoDTO>(url);
    }
}

